import { useEffect, useState } from "react";
import { useApplySettingsToDom } from "./useApplySettingsToDom";
import { useNotificationScheduler } from "../features/notifications/useNotificationScheduler";
import { Shell } from "./layout/Shell";
import { normalizePath, getPageComponent, type Route } from "./routes";
import { usePageTransition } from "./motion/pageTransitions";
console.log("DU_PROXY", import.meta.env.VITE_DU_PROXY_URL);
console.log("ICS_PROXY", import.meta.env.VITE_ICS_PROXY_URL);
console.log("ICS_KEY exists?", !!import.meta.env.VITE_ICS_KEY);

export default function App() {
  useApplySettingsToDom();
  useNotificationScheduler();

  const [path, setPath] = useState<Route>(() => normalizePath(window.location.pathname));

  useEffect(() => {
    const on = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", on);
    window.addEventListener("app:navigate", on);
    return () => {
      window.removeEventListener("popstate", on);
      window.removeEventListener("app:navigate", on);
    };
  }, []);

  const Page = usePageTransition(() => getPageComponent(path), path);

  return <Shell>{Page}</Shell>;
}
